import { useEffect, useRef } from "react";
import { Alert } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import config from "../../config/config.json";
import { useDocumentTitle } from "../../hooks/use-document-title";
import { saveStripeConnectInfo } from "../../services/projectService";

const StripeConnectPage: React.FC = () => {
  const navigate = useNavigate();
  useDocumentTitle("Stripe Connect");

  const projectId = window.localStorage.getItem(
    config.localStorageKeys.stripeConnectProjectId,
  );
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get("code");
  const scope = searchParams.get("scope");
  const savedRef = useRef(false);

  useEffect(() => {
    const handleSaveStripeConnectInfo = async () => {
      if (savedRef.current) {
        return;
      }

      if (code && scope && projectId) {
        savedRef.current = true;
        await saveStripeConnectInfo(projectId, code, scope);
        window.localStorage.removeItem(
          config.localStorageKeys.stripeConnectProjectId,
        );
        navigate(`/project/${projectId}`);
        toast.success("Stripe connected!");
      }
    };

    handleSaveStripeConnectInfo();
  }, [code, scope, projectId, navigate]);

  return (
    <div className="stripe-connect-page">
      <div className="page-header">Connect to Stripe</div>
      <Alert variant="info">
        If you're on this page, you're in the process of connecting to Stripe.
      </Alert>
    </div>
  );
};

export default StripeConnectPage;
